import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import './error-page.component.scss';
import { IonPage } from '@ionic/react';
import errorImage from '../../../../icons/error.svg';
import { Header } from '../../../sites/components/header.component';

interface ErrorPageProps {
  errorCode: string;
}

export const ErrorPage: FunctionComponent<ErrorPageProps> = ({ errorCode }) => {

  const { t } = useTranslation();

  return <IonPage color="background-color">
    <Header/>
    <img className="error_image" src={ errorImage } alt="lost dog"/>
    <div className="error-block">
      <h1 className="title">{ t('error.title') + " " +errorCode }</h1>
      <p className="subtitle">{ t('error.subtitle') }</p>
      <br/>
      <p className="contact">{ t('error.contactSupport') }
        <a className="mail" href={ 'mailto:support@stonal.com' }>support@stonal.com</a></p>
    </div>
  </IonPage>;
};
